<template>
<md-layout md-column class="ql-print-cue-list">
    <p v-if="!globalCues.length" class="md-body-2">You haven't created any cues on this page. Double click to add cues and right click to add notes.</p>
    <project-cues-cue v-for="(cue, index) in cues" 
        :key="cue.id" 
        :cue="cue"
        :open="isOpen(cue)"
        :class="cuePlacementclass(cue)"
        :locked="locked"
        :totalPages="totalPages"
        :selectedScale="selectedScale"
        :cuesListWidth="cuesListWidth"
        :svgContentWidth="svgContentWidth"
        :cueIndex="index"
        :landscape="landscape"
        :currentPage="currentPage"
        :openCues="openCues"
        @openCue="openCue(cue)" 
        @closeCue="closeCue(cue)"
        @destroy="destroy"
        @updatedCue="updatedCue" />
</md-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import ProjectCuesCue from '@/components/print/cues/cue';

const ProjectCueList = {
    name: 'projectCueList',
    props: ['cues', 'openCues', 'locked', 'totalPages', 'globalCues', 'selectedScale', 'cuesListWidth', 'svgContentWidth', 'landscape', 'currentPage'],
    data: function() {
        return {};
    },
    computed: {
        ...mapGetters([
            'cuePlacement',
            'layerByCue',
            'getDefaultCuePlacementPrint',
            'getPrintCuePlacement'
        ])
    },
    methods: {
        isOpen(cue) {
            return this.openCues.some(c => c.id === cue.id);
        },
        openCue(cue) {
            this.$emit('openCue', cue);
        },
        closeCue(cue) {
            this.$emit('closeCue', cue);
        },
        destroy(cue) {
            this.$emit('destroy', cue);
        },
        updatedCue(cue) {
            this.$emit('updatedCue', cue);
        },
        cuePlacementclass(cue) {
            const defaultCuePlacement = this.getPrintCuePlacement(cue.layer);
            return defaultCuePlacement.indexOf('right') === 0 ? 'right-edge' : 'left-edge';
        }
    },
    components: {
        'project-cues-cue': ProjectCuesCue
    }
};

export default ProjectCueList;
</script>

<style lang="scss">
.app-print-mode {
    .ql-print-cue-list {
        position: relative;
        padding-top: 6px;
        padding-left: 15px;
        flex: 0 0 30%;
        &.left-edge {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            max-width: 100%;
        }
        &.right-edge {
            position: absolute;
            left: auto;
            top: 0;
            width: 100%;
            height: 100%;
            max-width: 100%;
        }




        &:not(.right-edge), &:not(.left-edge) {
            position: absolute;
            left: auto;
            top: 0;
            width: 100%;
            height: 100%;
            max-width: 100%;
            padding: 0;
        }
    }
    .ql-page-layout.portrait {
        .ql-print-cue-list {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// cue-list.vue?3494d3ca